import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/react';
import { Integrations } from "@sentry/tracing";
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react'

import { Provider } from 'react-redux';

import './i18n';

import configureStore from './store';

import './fontawesome';

const instance = createInstance({
  urlBase: 'https://cpvo.matomo.cloud/',
  siteId: 3, // optional, default value: `1`
  trackerUrl: 'https://cpvo.matomo.cloud/matomo.php', // optional, default value: `${urlBase}matomo.php`
  srcUrl: 'https://cdn.matomo.cloud/cpvo.matomo.cloud/matomo.js', // optional, default value: `${urlBase}matomo.js`
  disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
  heartBeat: { // optional, enabled by default
    active: true, // optional, default value: true
    seconds: 10 // optional, default value: `15
  },
  linkTracking: true, // optional, default value: true
})

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_IO_URL!,
  integrations: [new Integrations.BrowserTracing()],
  environment     : "prod",
  release         : "cpvo-vf-frontend@" + process.env.REACT_APP_RELEASE,
  tracesSampleRate: 1.0
});

const store = configureStore();

ReactDOM.render(
  <MatomoProvider value={instance}>
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
</MatomoProvider>
 ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
